import { Box, InputAdornment, TextField } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { useEffect, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomMoneyInput = (props: GridRenderCellParams<any, number>) => {
  const { id, value, field, hasFocus } = props;
  const apiRef = useGridApiContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (newValue: string | null) => {
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  useEffect(() => {
    if (hasFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [hasFocus]);

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', pr: 2 }}>
      <TextField
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none'
            },
            '&:hover fieldset': {
              border: 'none'
            },
            '&.Mui-focused fieldset': {
              border: 'none'
            }
          }
        }}
        inputRef={inputRef}
        type="number"
        onChange={(e) => handleChange(e.target.value)}
        value={value}
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>
          }
        }}
      />
    </Box>
  );
};
